@if (therapeutenPage) {
  <mat-nav-list>
    <h3 class="subheader">
      Therapeuten
      @if (!therapeutenPage.isEmpty()) {
        <zah-sort-button
          [sortOrder]="initialPageRequest.getSortOrder()"
          (sortOrderChange)="onSortOrderChange($event)">
        </zah-sort-button>
      }
    </h3>
    @for (therapeut of therapeutenPage.getItems(); track therapeut) {
      <mat-list-item (click)="onTherapeutClick(therapeut)">
        <zah-avatar matListItemAvatar [name]="therapeut.getNaam()"></zah-avatar>
        <div matListItemTitle>{{therapeut.getNaam()}} <span class="mat-small">({{therapeut.getPersoneelsnummer()}})</span></div>
        <div matListItemLine class="mat-small">{{therapeut.getEmail()}}</div>
        <button matListItemMeta
          disableRipple="true"
          class="center-vertically"
          mat-icon-button
          (click)="$event.stopPropagation(); onDeleteClick(therapeut)">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </mat-list-item>
      <mat-divider></mat-divider>
    }
    @if (therapeutenPage.isEmpty()) {
      <mat-list-item
        class="no-list-item-highlight"
        disableRipple>
        <div matListItemTitle>Geen therapeuten gevonden</div>
      </mat-list-item>
    }
    <mat-list-item class="no-list-item-highlight overflow-visible-for-button-shading" disableRipple lines="2">
      <span matListItemMeta class="center-vertically">
        <button mat-mini-fab
          color="accent"
          (click)="onAddClick()">
          <mat-icon>add</mat-icon>
        </button>
      </span>
    </mat-list-item>
  </mat-nav-list>
  @if (!therapeutenPage.isEmpty()) {
    <zah-paginator
      [currentPage]="therapeutenPage"
      [pageSize]="initialPageRequest.getPageSize()"
      (pageSizeChange)="onPageSizeChange($event)"
      (pageChange)="onPageChange($event)">
    </zah-paginator>
  }
}
